import { render } from "./ResetPasswordView.vue?vue&type=template&id=1a7c1201&ts=true"
import script from "./ResetPasswordView.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__